module.exports = __webpack_public_path__ + "static/media/alert.a113e485.svg";